import {
  UtensilsCrossed,
  Scissors,
  Laptop,
  ShoppingBag,
  Wrench,
  Building2,
  PhoneCall,
  CalendarClock,
  ReceiptText,
  Megaphone,
  Sparkles,
} from "lucide-react";

const MAP = {
  UtensilsCrossed,
  Scissors,
  Laptop,
  ShoppingBag,
  Wrench,
  Building2,
  PhoneCall,
  CalendarClock,
  ReceiptText,
  Megaphone,
};

export default function DynamicIcon({ name, ...props }) {
  const Cmp = MAP[name] || Sparkles;
  return <Cmp {...props} />;
}
